import Vue from 'vue';
import Vuex from "vuex";
import {listBrands, listFavorites, listReservations, listStores} from "../graphql/queries";
import {AmplifyEventBus} from 'aws-amplify-vue';
import {API, graphqlOperation, Auth} from 'aws-amplify';
import {doCancelReservation, doCreateReservationForTime, doEnterStore, doLeaveStore} from "../graphql/mutations";
import {PAGE_IDS} from "../utils/constants";

const _ = require('lodash');
const {v4: uuidv4} = require('uuid');
const moment = require('moment-timezone')
Vue.use(Vuex);

export default {
  state: {
    start_data: '',
    end_date: '',
    store_id: undefined,
    type_users_to_generate: 'new',
    generated_users: [],
    num_reservations_to_generate: undefined,
  },
  mutations: {
    UPDATE_START_DATE: (state, date) => state.start_data = date,
    UPDATE_END_DATE: (state, date) => state.end_date = date,
    UPDATE_STORE_ID: (state, store) => state.store_id = store,
    UPDATE_USERS_TO_GENERATE: (state, num) => state.type_users_to_generate = num,
    UPDATE_RESERVATIONS_TO_GENERATE: (state, num) => state.num_reservations_to_generate = num,
    UPDATE_GENERATED_USERS: (state, user) => state.generated_users = [user, ...state.generated_users],
    CLEAR_GENERATED_USERS: (state) => state.generated_users = []

  },
  actions: {
    updateStartDate: ({commit}, date) => commit('UPDATE_START_DATE', date),
    updateEndDate: ({commit}, date) => commit('UPDATE_END_DATE', date),
    updateStoreId: ({commit}, store) => commit('UPDATE_STORE_ID', store),
    updateUsersToGenerate: ({commit}, num) => commit('UPDATE_USERS_TO_GENERATE', num),
    updateReservationsToGenerate: ({commit}, num) => commit('UPDATE_RESERVATIONS_TO_GENERATE', num),
    updateGeneratedUsers: ({commit}, user) => commit('UPDATE_GENERATED_USERS', user),
    clearGeneratedUsers: ({commit}) => commit('CLEAR_GENERATED_USERS'),
    generateFakeUser: ({getters, commit, dispatch}) => {
      var rand = Math.random()
      let generated_uuid = uuidv4()
      let user = {
        'username': `generated-email-${generated_uuid}@generated.com`,
        'password': '12345678',
        'attributes': {
          'name': `generated-name-${generated_uuid}`,
          'email': `generated-email-${generated_uuid}@generated.com`
        }
      }
      if (getters.getUsersToGenerate === 'new') {
        Auth.signUp(user)
          .then(() => {
            dispatch('updateGeneratedUsers', user.username)
          })
          .catch(e => {
            console.log(e)
          });
      } else {
        if (rand > 0.5) {
          Auth.signUp(user)
            .then(() => {
              dispatch('updateGeneratedUsers', user.username)
            })
            .catch(e => {
              console.log(e)
            });
        }

      }

    },
    generateFakeReservation: ({getters, commit, dispatch, rootGetters}) => {
      return new Promise((resolve, reject) => {
        if (getters.getStartDate && getters.getEndDate) {
          let start = moment.utc(getters.getStartDate)
          let end = moment.utc(getters.getEndDate)
          let range = moment.duration(end.diff(start)).asDays();
          let random_from_range = Math.floor(Math.random() * (range))
          let random_hour = Math.floor(Math.random() * (20 - 10)) + 10;
          let random_minute = Math.floor(Math.random() * (59 - 10)) + 10;
          let date = moment(start).add(random_from_range, 'days')
          let full_date = moment(start).add(random_from_range, 'days').add(random_hour, 'hours').add(random_minute, 'minutes')
          API.graphql(graphqlOperation(doCreateReservationForTime, {
            store_id: Array.isArray(getters.getStoreToFill) ? _.sample(getters.getStoreToFill) : getters.getStoreToFill,
            dt: moment.utc(full_date).startOf('minute').unix(),
            owner: (getters.getGeneratedUsers > 0) ? _.sample(getters.getGeneratedUsers) : rootGetters.currentUser.username,
            day_start_dt: moment.utc(date).startOf('minute').unix(),
            day_index: moment.utc(date).startOf('minute').isoWeekday(),
            first: getters.getGeneratedUsers > 0 ? 0 : 1
          }))
            .then((main_res) => {
              dispatch('addReservation', main_res.data.doCreateReservationForTime, {root: true})

              var rand = Math.random() // get a random number between 0 and 1
              var accumulatedChance = 0 // used to figure out the current

              let current_hour = parseInt(moment.utc().format('HH'))
              if (random_hour <= current_hour && moment.utc().isSame(full_date, 'day')) {
                if (rand < 0.8) {
                  API.graphql(graphqlOperation(doEnterStore, {
                    id: main_res.data.doCreateReservationForTime.id,
                    time: moment.utc(full_date).startOf('minute').unix(),
                  }))
                    .then((data) => {
                      API.graphql(graphqlOperation(doLeaveStore, {
                        id: main_res.data.doCreateReservationForTime.id,
                        time: moment.utc(full_date).endOf('minute').unix(),
                      }))
                        .then((res) => {
                          resolve()
                        })
                        .catch((e) => {
                          console.log(`Error Leaving Store`, e)
                          reject()
                        });
                      resolve()
                    })
                    .catch((e) => {
                      console.log(`Error Entering Store`, e)
                      reject()
                    });
                } else {
                  API.graphql(graphqlOperation(doCancelReservation, {
                    reservation_id: main_res.data.doCreateReservationForTime.id,
                    owner: main_res.data.doCreateReservationForTime.owner
                  }))
                    .then((res) => {
                      dispatch('updateReservation', res.data.doCancelReservation, {root: true})
                      resolve()
                    })
                    .catch((e) => {
                      console.log(`Error Cancelling reservation`, e)
                      reject()
                    });
                }

              } else {
                if (moment(full_date).isAfter(moment.utc())) {
                  if (rand < 0.3) {
                    API.graphql(graphqlOperation(doCancelReservation, {
                      reservation_id: main_res.data.doCreateReservationForTime.id,
                      owner: main_res.data.doCreateReservationForTime.owner
                    }))
                      .then((res) => {
                        dispatch('updateReservation', res.data.doCancelReservation, {root: true})
                        resolve()
                      })
                      .catch((e) => {
                        console.log(`Error Cancelling reservation`, e)
                        reject()
                      });
                  }
                  resolve()
                } else {
                  if (rand < 0.4) {
                    if (rand < 0.2) {
                      resolve()
                    } else {
                      API.graphql(graphqlOperation(doCancelReservation, {
                        reservation_id: main_res.data.doCreateReservationForTime.id,
                        owner: main_res.data.doCreateReservationForTime.owner
                      }))
                        .then((res) => {
                          dispatch('updateReservation', res.data.doCancelReservation, {root: true})
                          resolve()
                        })
                        .catch((e) => {
                          console.log(`Error Cancelling reservation`, e)
                          reject()
                        });
                    }

                  } else {
                    API.graphql(graphqlOperation(doEnterStore, {
                      id: main_res.data.doCreateReservationForTime.id,
                      time: moment.utc(full_date).startOf('minute').unix(),
                    }))
                      .then((data) => {
                        API.graphql(graphqlOperation(doLeaveStore, {
                          id: main_res.data.doCreateReservationForTime.id,
                          time: moment.utc(full_date).endOf('minute').unix(),
                        }))
                          .then((res) => {
                            resolve()
                          })
                          .catch((e) => {
                            console.log(`Error Leaving Store`, e)
                            reject()
                          });
                        resolve()
                      })
                      .catch((e) => {
                        console.log(`Error Entering Store`, e)
                        reject()
                      });
                  }
                  resolve()
                }
                resolve()
              }
            })
            .catch((e) => {
              console.log(`Error Creating Reservation`, e)
              reject()
            });
        } else {
          reject()
        }
      })

    },

    generateData: async ({getters, commit, dispatch}) => {
      dispatch('startLoading', null, {root: true})
      let amount = 0
      if (getters.getUsersToGenerate === 'new' || getters.getUsersToGenerate === 'both') {
        dispatch('generateFakeUser');
      }
      if (getters.getReservationsToGenerateNum > 0) {

        for (let i = 0; i < getters.getReservationsToGenerateNum; i++) {
          await dispatch('generateFakeReservation')

        }
        dispatch('stopLoading', null, {root: true})
        dispatch('clearGeneratedUsers')
      }


    }
  },
  getters: {
    getGeneratedUsers: (state, getters) => state.generated_users,
    getStoreToFill: (state, getters) => state.store_id,
    getUsersToGenerate: (state, getters) => state.type_users_to_generate,
    getReservationsToGenerateNum: (state, getters) => state.num_reservations_to_generate,
    getStartDate: (state, getters) => state.start_data,
    getEndDate: (state, getters) => state.end_date,
  },

};



// WEBPACK FOOTER //
// ./src/store/fake_data_store.js